<template>
    <b-modal id="modal-konfirmasi" title="Konfirmasi Gadai" size="lg" 
        no-close-on-backdrop no-close-on-esc :hide-header-close="isSubmitting"
        :ok-title="isSubmitting ? 'Menyimpan...' : 'Simpan'" 
        :ok-disabled="isSubmitting"
        @ok.prevent="doSubmit" auto-focus-button="ok"
        cancel-title="Tutup"
    >
        Dengan ini akan melakukan penggadaian dengan data sebagai berikut:
        <div class="detail-data-wrapper mb-4 mt-4">
            <h6 class="form-title mb-2">ANGGOTA</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">No. Anggota</b-col>
                <b-col>
                    {{ anggota.no }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nama</b-col>
                <b-col>
                    {{ anggota.nama }}
                </b-col>
            </b-row>
        </div>
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">DATA GADAI</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Barang</b-col>
                <b-col>
                    {{ namaLengkapBarang }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nilai Pinjaman</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(nilaiPinjaman) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.biayaJasaPertama != null">
                <b-col cols="5" class="detail-data-label">Biaya Jasa</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.biayaJasaPertama) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Admin Fee</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.biayaAdmin) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nasabah mendapatkan</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.jumlahDiterima) }}
                </b-col>
            </b-row>
        </div>
        Pastikan anda sudah mengisi data penggadaian dengan sebenar-benarnya sebelum menyimpan.
    </b-modal>
</template>

<script>
export default {
    name: 'modal-konfirmasi',
    props: {
        isSubmitting: { type: Boolean, required: true },
        nilaiPinjaman: { type: Number, required: true },
        anggota: { type: Object, required: true },
        rincian: { type: Object, required: true },
        namaLengkapBarang: { type: String, required: true },
    },
    methods: {

        doSubmit() {
            this.$emit("exec-submit")
        }

    }
}
</script>